@if (badge$ | async; as badge) {
    <div class="badge">
        <img [src]="badge.image" />
    </div>
}
